// Add your custom JS here.

(function ($) {
    function checkHeight(ele) {
        var h = 0;
        $(ele).each(function () {
            if ($(this).height() > h) {
                h = $(this).height();
            }
        });
        $(ele).css('height', h + 'px');
    }

    function setFullHeight() {
        document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`);
    }

    window.addEventListener('resize', setFullHeight);
    setFullHeight();

    $(document).ready(function () {
        let lastScrollTop = 0;
        const delta = 5; // Độ trễ nhỏ trước khi thực thi
        const headerHeight = $('header').outerHeight();
        const headerTop = $('.header__top');
        const headerTopHeight = headerTop.outerHeight();
        const topSticky = headerHeight - headerTopHeight + 10;

        $(window).on('scroll', function () {
            
            let st = $(this).scrollTop();
            let translateValue = -Math.min(st, headerTopHeight);

            headerTop.css('margin-top', translateValue+'px');

            // Chỉ thực thi khi người dùng cuộn nhiều hơn giá trị delta
            if(st <= delta) {
                $('header').removeClass('show');
                return;
            }

            // Nếu cuộn xuống và vị trí cuộn lớn hơn chiều cao của header
            if (st > lastScrollTop && st > headerHeight){
                // Cuộn xuống
                $('header').removeClass('show').addClass('hide');
                $('.summary').css('top', '10px');
            }
            if(st <= lastScrollTop) {
                // Cuộn lên
                $('header').removeClass('hide').addClass('show');
                $('.summary').css('top', topSticky+'px');
            }

            lastScrollTop = st;

            //Nút totop
            if ($(window).scrollTop() > 100) {
                $('.toTop').addClass('active');
            } else {
                $('.toTop').removeClass('active');
            }
        });

        $('.toTop').on('click', function (e) {
            e.preventDefault();
            $('html, body').animate({
                scrollTop: 0
            }, 'swing');
        });

        $('.menu-item-has-children').append('<button type="button" class="btnSub"><i class="far fa-angle-down"></i></button>');

        $(document).on('click', '.btnSub', function (e) {
            e.preventDefault();
            $(this).toggleClass('active').siblings('.subMenu').slideToggle(300);
        });

        $(document).on('click', '.showMenu', function(e) {
            e.preventDefault();
            if($(this).hasClass('openSearch')) {
                $('.js-menu').hide(0);
                $('.js-search').show(0);
                $('.header__fixed').addClass('show');
            } else {
                $('.js-search').hide(0);
                $('.js-menu').show(0);
                $('.header__fixed').addClass('show');
            }
        });

        $(document).on('click', '.closeMenu', function(e) {
            e.preventDefault();
            $('.header__fixed').removeClass('show');
        });

        if($('.header__menu .menu-item').length) {
            $('.header__menu .menu-item').each(function() {
                const imgTarget = $(this).data('image');
                
                if(imgTarget) {
                    $(this).on('mouseenter', function() {
                        $(`#${imgTarget}`).addClass('show');
                    }).on('mouseleave', function() {
                        $(`#${imgTarget}`).removeClass('show');
                    });
                }
            });
        }

        if($('.bestSallingProd__slider').length) {
            const bestSallingProd__slider = new Swiper('.bestSallingProd__slider', {
                slidesPerView: 2.2,
                spaceBetween: 10,
                navigation: {
                    prevEl: '.bestSallingProd__slider .swiper-button-prev',
                    nextEl: '.bestSallingProd__slider .swiper-button-next'
                },
                pagination: false,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                speed: 800,
                // Responsive breakpoints
                breakpoints: {
                    // when window width is >= 320px
                    320: {
                        slidesPerView: 1.3,
                        spaceBetween: 8
                    },
                    // when window width is >= 480px
                    480: {
                        slidesPerView: 1.3,
                        spaceBetween: 8
                    },
                    // when window width is >= 640px
                    640: {
                        slidesPerView: 2,
                        spaceBetween: 8
                    },
                    // when window width is >= 640px
                    991: {
                        slidesPerView: 2.2,
                        spaceBetween: 36
                    }
                }
            });
        }

        // Chỉ chạy code nếu slider cha tồn tại
        if ($('.fullPage').length) {
            // Chỉ số (index) của slide cha chứa slider con
            // Ví dụ: slide thứ 5 sẽ có index là 4
            const nestedSlideIndex = 4;

            let homeElementSlider; // Khai báo biến slider con ở ngoài để có thể truy cập ở mọi nơi

            // Khởi tạo slider cha (fullPage)
            const fullPage = new Swiper(".fullPage", {
                direction: "vertical",
                slidesPerView: "auto",
                spaceBetween: 0,
                mousewheel: true, // Bật mousewheel cho slider cha
                speed: 800,
                on: {
                    // Đây là bộ điều khiển trung tâm
                    slideChange: function (swiper) {
                        // Nếu slide hiện tại LÀ slide chứa slider con
                        // if (swiper.activeIndex === nestedSlideIndex) {
                        //     // Tắt mousewheel của slider cha để trao quyền cho slider con
                        //     swiper.mousewheel.disable();
                        // } else {
                        //     // Nếu là slide khác, đảm bảo mousewheel của slider cha được bật
                        //     swiper.mousewheel.enable();
                        // }

                        $(swiper.slides).find('[data-aos]').removeClass('aos-animate');
                        $(swiper.slides[swiper.activeIndex]).find('[data-aos]').addClass('aos-animate');

                        // Các logic khác của bạn
                        const currentIndex = swiper.activeIndex;
                        const previousIndex = swiper.previousIndex;
                        if(currentIndex > 0) {
                            $('.fullPageTop').addClass('show');
                        } else {
                            $('.fullPageTop').removeClass('show');
                        }
                        
                        if (currentIndex > previousIndex) {
                            $('#header').addClass('hide');
                        } else if (currentIndex < previousIndex || currentIndex == 0) {
                            $('#header').removeClass('hide');
                        }

                        if(currentIndex >= 3) {
                            $('#header').removeClass('dark');
                        } else {
                            $('#header').addClass('dark');
                        }

                        setTimeout(() => {
                            if ($('.swiper-slide-active .process .figureNumber').length) {
                                $('.process .figureNumber').each(function () {
                                    runCounter($(this));
                                });
                            }
                        }, 800);
                    },
                    reachBeginning: function() {
                        $('#header').removeClass('hide');
                    },
                    reachEnd: function() {
                        $('#header').addClass('hide');
                    }
                }
            });

            $(document).on('click', '.fullPageTop', function(e) {
                e.preventDefault();
                fullPage.slideTo(0, 1000);
            });

            // Chỉ khởi tạo slider con và thêm sự kiện nếu nó tồn tại
            if ($('.homeElement__slider').length) {
                const childSwiperContainer = document.querySelector('.homeElement__slider');

                homeElementSlider = new Swiper(".homeElement__slider", {
                    direction: "vertical",
                    slidesPerView: "auto",
                    spaceBetween: 0,
                    mousewheel: true, // Bật mousewheel cho slider con
                    nested: true,     // Rất quan trọng cho slider con
                    speed: 800,
                    // KHÔNG cần khóa cuộn chuột trong slider con nữa
                    // on: { ... }
                });

                // Lắng nghe sự kiện lăn chuột trực tiếp trên slider con
                childSwiperContainer.addEventListener('wheel', (event) => {
                    // Nếu slider con chưa được khởi tạo thì thoát
                    if (!homeElementSlider) return;

                    // event.deltaY < 0 là cuộn lên
                    // event.deltaY > 0 là cuộn xuống

                    // Nếu cuộn lên VÀ slider con đang ở slide đầu tiên
                    if (event.deltaY < 0 && homeElementSlider.isBeginning) {
                        // Bật lại mousewheel của slider cha để nó cuộn lên
                        fullPage.mousewheel.enable();
                    }
                    // Nếu cuộn xuống VÀ slider con đang ở slide cuối cùng
                    else if (event.deltaY > 0 && homeElementSlider.isEnd) {
                        // Bật lại mousewheel của slider cha để nó cuộn xuống
                        fullPage.mousewheel.enable();
                    }
                });
            }
        }

        if ($('.heroSlider').length) {
            const heroSlider = new Swiper('.heroSlider', {
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                speed: 800,
                navigation: false,
                pagination: {
                    el: ".heroSlider .swiper-pagination",
                    clickable: true
                },
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                }
            });
        }

        if($('.piIntro__bg').length) {
            const video = $('.piIntro__bg');
            const videoElem = video[0];
            const playBtn = $('.piIntro__play');
            const muteBtn = $('.piIntro__mute');

            playBtn.on('click', function(e) {
                e.preventDefault();
                if(videoElem.paused) {
                    videoElem.play();
                    $(this).removeClass('pause');
                } else {
                    videoElem.pause();
                    $(this).addClass('pause');
                }
            });

            muteBtn.on('click', function(e) {
                e.preventDefault();
                if(videoElem.muted) {
                    $(this).addClass('unmuted');
                    videoElem.muted = false;
                } else {
                    $(this).removeClass('unmuted');
                    videoElem.muted = true;
                }
            });
        }

        if($('.expVideo__source').length) {
            const video = $('.expVideo__source');
            const videoElem = video[0];
            const playBtn = $('.expVideo__play');
            const muteBtn = $('.expVideo__mute');

            playBtn.on('click', function(e) {
                e.preventDefault();
                if(videoElem.paused) {
                    videoElem.play();
                    $(this).removeClass('pause');
                } else {
                    videoElem.pause();
                    $(this).addClass('pause');
                }
            });

            muteBtn.on('click', function(e) {
                e.preventDefault();
                if(videoElem.muted) {
                    $(this).addClass('unmuted');
                    videoElem.muted = false;
                } else {
                    $(this).removeClass('unmuted');
                    videoElem.muted = true;
                }
            });
        }

        function runCounter($element) {
            if (!$element.hasClass("counted")) {
                var numberString = $element.html();
                var cleanedNumberString = numberString.replace(/\./g, '');
                var targetNumber = parseInt(cleanedNumberString, 10);

                if (!isNaN(targetNumber)) {
                    $element.addClass("counted");
                    $({ countNum: 0 }).animate({ countNum: targetNumber }, {
                        duration: 3000,
                        easing: "linear",
                        step: function () {
                            let currentNum = Math.floor(this.countNum);
                            let formattedNum = currentNum.toLocaleString('de-DE', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0
                            });
                            $element.text(formattedNum);
                        },
                        complete: function () {
                            let formattedTarget = targetNumber.toLocaleString('de-DE', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0
                            });
                            $element.text(formattedTarget);
                        }
                    });
                } else {
                    console.error("Lỗi: Không thể chuyển đổi '" + numberString + "' thành số hợp lệ.");
                }
            }
        }

        setTimeout(function () {
            AOS.init({ disable: 'mobile', once: true });

            if ($('.serviceItem__imgs a[data-fancybox]').length) {
                Fancybox.bind('.serviceItem__imgs a[data-fancybox]', {
                    Carousel: {
                        Zoomable: {
                            Panzoom: {
                                clickAction: "iterateZoom",
                                maxScale: 2,
                            },
                        },
                    },
                });
            }

            if ($('.sf-field-search .sf-input-text').length) {
                $('.sf-field-search .sf-input-text').addClass('form-control');
            }
            if ($('.sf-field-sort_order .sf-input-select').length) {
                $('.sf-field-sort_order .sf-input-select').addClass('form-select');
            }
        }, 500);

        $(document).on('click', '.work', function (e) {
            e.preventDefault();
            const post_id = $(this).data('id');
            $.ajax({
                url: ajax_object.ajax_url,
                type: 'POST',
                data: {
                    action: 'load_acf_gallery',
                    post_id: post_id,
                    nonce: ajax_object.nonce
                },
                success: function (response) {
                    if (response.success && response.data.length > 0) {
                        Fancybox.show(response.data);
                    } else {
                        alert('Không tìm thấy album ảnh.');
                    }
                }
            });
        });

    });

    window.addEventListener('load', () => {
        const marqueeContainer = document.getElementById('myMarquee');
        if (!marqueeContainer) {
            console.error("Marquee container '#myMarquee' not found.");
            return;
        }

        const marqueeWrapper = marqueeContainer.querySelector('.marqueeContainer');
        if (!marqueeWrapper) {
            console.error("Marquee wrapper '.marqueeContainer' not found inside '#myMarquee'.");
            return;
        }

        const originalItems = Array.from(marqueeWrapper.children);
        if (originalItems.length === 0) {
            console.warn("Marquee wrapper has no child elements.");
            return; // No items to animate
        }

        // --- Configuration ---
        const speed = 80; // pixels per second
        const direction = -1; // -1: Left, 1: Right (Current logic best supports -1)
        let pauseOnHover = true;

        // --- Clone items ---
        // Clear existing clones if the script runs again (e.g., in development)
        while (marqueeWrapper.children.length > originalItems.length) {
            marqueeWrapper.removeChild(marqueeWrapper.lastChild);
        }
        // Clone
        originalItems.forEach(item => {
            const clone = item.cloneNode(true);
            // Optional: Add a class or attribute to identify clones for debugging
            // clone.setAttribute('data-clone', 'true');
            marqueeWrapper.appendChild(clone);
        });

        // --- Calculate width and duration based on actual rendered width ---
        // Ensure styles are applied and layout is calculated
        // requestAnimationFrame can help ensure layout is stable before measuring
        requestAnimationFrame(() => {
            // Measure the total width of the wrapper containing original + clones
            const totalWidth = marqueeWrapper.scrollWidth;

            // The width needed for one cycle is half of the total width
            const resetWidth = totalWidth / 2;

            // If calculated width is zero or container is not wide enough for scrolling, stop.
            if (resetWidth <= 0 || resetWidth <= marqueeContainer.offsetWidth) {
                // console.warn("Marquee content is not wide enough to scroll or width calculation failed.");
                // Optionally remove clones if not scrolling
                while (marqueeWrapper.children.length > originalItems.length) {
                    marqueeWrapper.removeChild(marqueeWrapper.lastChild);
                }
                return;
            }

            // Calculate duration
            const duration = (speed > 0) ? (resetWidth / speed) * 1000 : 0; // in ms

            // Cancel any previous animation on the wrapper
            if (marqueeWrapper.animation) {
                marqueeWrapper.animation.cancel();
            }

            // --- Create Animation using WAAPI ---
            if (duration > 0) {
                const animation = marqueeWrapper.animate(
                    [
                        { transform: `translateX(25px)` },
                        { transform: `translateX(${direction * resetWidth}px)` }
                    ],
                    {
                        duration: duration,
                        iterations: Infinity,
                        easing: 'linear'
                    }
                );

                // Store the animation object
                marqueeWrapper.animation = animation;

                // --- Handle Pause/Play on Hover ---
                if (pauseOnHover) {
                    // Use variables to store bound functions for easy removal later if needed
                    const pauseAnimation = () => marqueeWrapper.animation?.pause();
                    const playAnimation = () => marqueeWrapper.animation?.play();

                    marqueeContainer.addEventListener('mouseenter', pauseAnimation);
                    marqueeContainer.addEventListener('mouseleave', playAnimation);

                    // Optional: Store listeners for potential cleanup
                    marqueeContainer.animationListeners = { pauseAnimation, playAnimation };
                }
            } else {
                // If duration is 0, ensure clones are removed if they were added
                while (marqueeWrapper.children.length > originalItems.length) {
                    marqueeWrapper.removeChild(marqueeWrapper.lastChild);
                }
            }
        }); // End of requestAnimationFrame

    });

})(jQuery)

// Đảm bảo mã chỉ chạy sau khi toàn bộ trang đã được tải
document.addEventListener('DOMContentLoaded', function() {

  /**
   * Hàm này sẽ tìm một ô input bằng ID,
   * sau đó bọc nó lại và thêm icon hiển thị mật khẩu.
   * @param {string} inputId ID của ô input mật khẩu.
   */
  function addShowPasswordToggle(inputId) {
    const passwordInput = document.querySelector(inputId);

    // Nếu không tìm thấy ô input, dừng hàm
    if (!passwordInput) {
      return;
    }

    // Tạo các phần tử cần thiết
    const wrapper = document.createElement('span');
    wrapper.classList.add('password-wrapper');

    const icon = document.createElement('i');
    icon.classList.add('show-password-icon');
    icon.textContent = '👁️'; // Icon ban đầu

    // Lấy thẻ cha của input để chèn wrapper vào
    const parent = passwordInput.parentElement;
    parent.insertBefore(wrapper, passwordInput);

    // Di chuyển input vào bên trong wrapper và thêm icon vào sau nó
    wrapper.appendChild(passwordInput);
    wrapper.appendChild(icon);

    // Gán sự kiện click cho icon vừa tạo
    icon.addEventListener('click', function() {
      if (passwordInput.type === 'password') {
        passwordInput.type = 'text';
        this.textContent = '🙈';
      } else {
        passwordInput.type = 'password';
        this.textContent = '👁️';
      }
    });
  }

  // Áp dụng chức năng này cho các ô mật khẩu phổ biến của WooCommerce
  addShowPasswordToggle('#password'); // Form đăng nhập
//   addShowPasswordToggle('#reg_password'); // Form đăng ký
//   addShowPasswordToggle('#account_password'); // Form đổi mật khẩu
//   addShowPasswordToggle('#password_current'); // Form đổi mật khẩu
//   addShowPasswordToggle('#password_1'); // Form đổi mật khẩu
//   addShowPasswordToggle('#password_2'); // Form đổi mật khẩu
});